import Confirmation from '../components/Confirmation.vue';
import Vue from 'vue';
const confirmationHandler = (titulo, mensaje, callback, aceptar, cancelar, callback2) => {
  const vm = new Vue({
    ...Confirmation,
    propsData: { titulo, mensaje, callback, aceptar, cancelar, callback2},
  });
  vm.$mount();
  vm.$bvModal.show('confirmation-modal');
};
export default confirmationHandler;
